import { createSelector } from "reselect";

import { EntityType } from "@mapmycustomers/shared";

import { RootState } from "@app/store/rootReducer";

import { SourceObjectEntityType } from "./constants";
import { InternalFieldDescription } from "./EntityColumnsConfiguration";
import RecordPreviewConfigurationColumns from "./RecordPreviewConfigurationColumns";
import appendSubtypeColumns from "./util/appendSubtypeColumns";

const recordPreviewState = (state: RootState) => state.recordPreview;

export const getRecordPreviewConfiguration = createSelector(
  recordPreviewState,
  ({ configuration }) => configuration
);

export const isRecordPreviewConfigurationLoading = createSelector(
  recordPreviewState,
  ({ loading }) => loading
);

const toFields = (rows: InternalFieldDescription[]) => rows.map(({ field }) => field);

export const getRecordPreviewConfigurationColumns = createSelector(
  getRecordPreviewConfiguration,
  (configuration): RecordPreviewConfigurationColumns => {
    const shared = {
      [EntityType.ACTIVITY]: toFields(configuration[EntityType.ACTIVITY]),
      [EntityType.COMPANY]: toFields(configuration[EntityType.COMPANY]),
      [EntityType.DEAL]: toFields(configuration[EntityType.DEAL]),
      [EntityType.PERSON]: toFields(configuration[EntityType.PERSON]),
    };
    // Each subtype's list is merged with its record type's shared list here, once per
    // configuration, so a reader never merges
    const getSubtypeColumns = (entityType: SourceObjectEntityType) =>
      new Map(
        configuration.subtypeLists[entityType].map(({ fields, key }) => [
          key,
          toFields(appendSubtypeColumns(configuration[entityType], fields)),
        ])
      );

    return {
      actions: !!configuration.actions.visibility,
      bySubtype: {
        [EntityType.COMPANY]: getSubtypeColumns(EntityType.COMPANY),
        [EntityType.PERSON]: getSubtypeColumns(EntityType.PERSON),
      },
      engagement: !!configuration.engagement.visibility,
      shared,
    };
  }
);
